<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>lblDelete</h4>
    <button type="button"  (click)="onCrossClickModel()" #closeModal id="modelButton" class="close" aria-label="Center Align">
        <span aria-hidden="true">×</span>
    </button>
</div>
<div class="modal-body ">

    <div class="card pad15 min-h250">
        <div class="row">
            <div class="col-12">
                <div class="af-form-group">
                    <label translate class="title16 mb-3">lblSelectReasonForOnDeleteAppointment</label>
                    <div *ngFor="let item of onHoldStatusReasonList;let i=index" class="form-check pl-0 mb-2">
                        <input type="checkbox" name="reason" id="reason-{{i}}" [(ngModel)]="item.isSelected"
                            (change)="reasonCheckboxChange(item.reasonId,i,item.isSelected)">

                        <span class="ml-3">{{item.reason}}</span>
                        <div class="row" *ngIf="item.isDescriptionRequire">
                            <div class="mt-1 col-8 pl-5">
                                <textarea class="form-control" name="textDescription" [(ngModel)]="item.description"
                                    maxlength="1000" [disabled]=" (item.reasonId!==selectedReasonId)">

                            </textarea>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="d-flex flex-sm-row flex-column justify-content-end" >
            <button type="button" class="btn btn-primary mr-sm-2" aria-label="Center Align"
                 [disabled]="!selectedReasonId" (click)="submiteOnDeleteDetails()"
                translate>lblUpdate</button>
            <button type="button" class="btn btn-secondary " aria-label="Center Align" (click)="onCrossClickModel()"
                translate>lblCancel</button>
        </div>
    </div>